import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isAfter, isValid, parse } from "date-fns";
import * as Yup from "yup";
import { useAluno } from "@/hooks/alunos";
import { Form, Input } from "@/components/Form";
import { Row, Col } from "@/components/Grid";
import { Button } from "@/components/Common";

import api, { makeOptions } from "@/services/api";
import toastify from "@/services/toastify";

import { ModalContent, ModalBody, ModalFooter } from "./styles";

export default function ModalEditAtividade({ onClose, data }) {
  const [formData, setFormData] = useState(null);
  const { data: user } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const { aluno, fetchAluno } = useAluno();

  const schema = Yup.object().shape({
    nome: Yup.string().required("Obrigatório"),
    descricao: Yup.mixed(),
    data_inicio: Yup.date()
      .typeError("Data inválida")
      .required("Obrigatório"),
    data_termino: Yup.mixed()
      .test("data-conclusao-maior", "Data inválida", function(value) {
        if (value === "") return true;
        const termino = parse(`${value}`, "yyyy-MM-dd", new Date());
        return isValid(termino) && isAfter(termino, this.parent.data_inicio);
      })
      .notRequired(),
  });

  async function updateAtividade(data, resetForm) {
    setLoading(true);
    const endpoint = `alunos/curriculos/atividades-complementares/${formData.id}`;
    const alunoId = aluno.id;
    data.aluno_id = alunoId;
    const { data: response } = await api.put(endpoint, data, makeOptions(user));
    setLoading(false);
    if (response.success) {
      toastify("Atividade complementar salva com sucesso");
      fetchAluno(alunoId);
      resetForm();
      onClose();
    }
  }

  function handleOnChange(event) {
    const { name, value } = event.target;
    setFormData(state => {
      return { ...state, ...{ [name]: value } };
    });
  }

  function handleSubmit(data, { resetForm }) {
    updateAtividade(data, resetForm);
  }

  useEffect(() => {
    setFormData(data);
  }, [data]);

  return (
    <ModalContent>
      {formData && (
        <Form onSubmit={handleSubmit} schema={schema} initialData={formData}>
          <ModalBody>
            <Row>
              <Col>
                <Input
                  label="Nome da atividade"
                  name="nome"
                  value={formData.nome || ""}
                  onChange={handleOnChange}
                />
              </Col>
            </Row>
            <Row hascols>
              <Col>
                <Input
                  type="date"
                  max="2099-01-01"
                  label="Data de início"
                  name="data_inicio"
                  value={formData.data_inicio || ""}
                  onChange={handleOnChange}
                />
              </Col>
              <Col>
                <Input
                  type="date"
                  max="2099-01-01"
                  label="Data de término (ou previsão)"
                  name="data_termino"
                  value={formData.data_termino || ""}
                  onChange={handleOnChange}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Input
                  multiline
                  showLength
                  maxLength={500}
                  label="Descrição da atividade"
                  name="descricao"
                  value={formData.descricao || ""}
                  onChange={handleOnChange}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button variant="cancel" onClick={onClose}>
              CANCELAR
            </Button>
            <Button
              type="submit"
              variant="tangerine"
              loading={loading || undefined}
            >
              SALVAR ALTERAÇÕES
            </Button>
          </ModalFooter>
        </Form>
      )}
    </ModalContent>
  );
}
